import { HERO_FEATURED } from "@/lib/products";
import { Link } from "react-router-dom";

export default function Hero() {
  const feature = HERO_FEATURED[0];

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-black pt-28 md:pt-36 pb-16 md:pb-24"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-[70vh] lg:min-h-[80vh]">
          {/* Text column */}
          <div className="max-w-xl fade-up">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight text-white mb-4">
              Your Moments,<br />Engraved Forever.
            </h1>

            <h2 className="font-sans text-xl md:text-2xl text-white/90 mb-6">
              Personalised Gold &amp; 99.9 Fine Silver Keepsakes
            </h2>

            <span className="block text-sm uppercase tracking-widest-2 text-[#d4af37] font-medium mb-6">
              Starting from ₹2,000
            </span>

            <p className="font-sans text-base md:text-lg text-white/70 leading-relaxed max-w-md mb-10">
              Turn your most meaningful memories into precious keepsakes, crafted in gold and 99.9 fine silver.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/catalog"
                data-testid="hero-cta-catalog"
                className="inline-flex items-center justify-center rounded-none px-8 py-4 bg-white text-black font-medium tracking-wide transition-colors hover:bg-gray-200"
              >
                Explore Collection
              </Link>
              <a
                href="#personalize"
                data-testid="hero-cta-personalize"
                className="inline-flex items-center justify-center rounded-none px-8 py-4 border border-white/20 text-white font-medium tracking-wide transition-colors hover:border-white"
              >
                Create Your Keepsake
              </a>
            </div>

            <span className="block text-[11px] uppercase tracking-widest-2 text-white/50 mt-10">
              99.9 Fine Silver · Gold · Personalised Engravings · Pan-India Delivery
            </span>
          </div>

          {/* Image column */}
          <div className="fade-up fade-up-delay-1">
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none overflow-hidden rounded-sm">
              <img
                src={feature.image}
                alt={feature.title}
                loading="eager"
                className="w-full h-full object-cover"
                data-testid="hero-featured-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
